import Project from '../models/Project'
import * as types from '../constants/types'

const initialState = {
  isFetching: false,
  project: new Project(),
  error: "",
  errMessage: "",
  attributes: null,
  questionnaire: null,
  lineItemHistory: null,
  attributesDetails: [],
  lineitemsByProjectId: []
}

export function project(state = initialState, action) {
  switch(action.type) {
    case types.PROJECT_COMMENCE_FETCH:
    return {
      ...state,
      isFetching: true
    }
    case types.PROJECT_DID_LOAD:
    return {
      ...state,
      project: new Project(action.payload.project),
      viewState: types.PROJECT_DID_LOAD,
    }
    case types.PROJECT_DID_ERROR:
    return {
      ...state,
      isFetching: false,
      error: action.payload.error
    }
    case types.PROJECT_RESET_ERROR:
    return {
      ...state,
      error: ""
    }
    case types.ATTRIBUTES_DID_LOAD:
    return {
      ...state,
      attributes: action.payload.attributes,
      isFetching: false,
      viewState: types.ATTRIBUTES_DID_LOAD,
    }
    case types.ATTRIBUTES_DETAILS_DID_LOAD:
    return {
      ...state,
      attributesDetails: action.payload.attributesDetails,
      viewState: types.ATTRIBUTES_DETAILS_DID_LOAD,
      isFetching: false
    }
    case types.LINEITEMS_DID_LOAD:
    return {
      ...state,
      attributes: null,
      lineItemHistory: null,
      attributesDetails: [],
      isFetching: false,
      viewState: types.LINEITEMS_DID_LOAD
    }
    case types.SURVEY_QA_SAVED:
    return {
      ...state,
      isFetching: false,
      viewState: types.SURVEY_QA_SAVED,
    }
    case types.USER_ASSIGNMENT_UPDATE_SUCCUSS:
    return {
      ...state,
      isFetching: false,
      viewState: types.USER_ASSIGNMENT_UPDATE_SUCCUSS,
    }
    case types.LINEITEMS_BY_PROJECTID:
    return {
      ...state,
      isFetching: false,
      lineitemsByProjectId: action.payload,
    }
    case types.SERVER_ERROR:
    return {
      ...state,
      viewState: types.SERVER_ERROR,
      errMessage: action.err.message
    }
    case types.QUESTIONNAIRE_DID_LOAD:
    return {
      ...state,
      isFetching: false,
      questionnaire: action.payload.questionnaire,
      viewState: types.QUESTIONNAIRE_DID_LOAD,
    }
    case types.HISTORY_DID_LOAD:
    return {
      ...state,
      isFetching: false,
      lineItemHistory: action.payload.lineItemHistory,
      viewState: types.HISTORY_DID_LOAD,
    }
    default:
    return state
  }
}
